import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * Project "Show in client portal" toggle + phase-status visibility. Proxies
 * through graphql/ to the portal internal admin API.
 *
 * The payload selects the project node rather than the config type: the
 * config type carries no id, so a config-only payload lands in a record
 * nothing references and the surface re-hydrates from the pre-save value
 * until an unrelated refetch replaces it.
 */
const mutation = graphql`
	mutation updateProjectPortalConfigMutation($input: UpdateProjectPortalConfigInput!) {
		updateProjectPortalConfig(input: $input) {
			project {
				id
				portalConfig {
					showInClientPortal
					portalPhaseStatusVisible
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
